import mikeyLogo from "../../assets/mikey-logo-transparent.png";
import mikeyLogoWhite from "../../assets/mikey-logo-white-transparent.png";

export const Logo = ({ className = "h-9 w-auto", variant = "default" }) => {
  const logoSrc = variant === "white" ? mikeyLogoWhite : mikeyLogo;

  return <img src={logoSrc} alt="Mikey Logo" className={className} />;
};
